import { getWithStatus, getQsNested } from "lib/http";

const queryFn = async ({ queryKey }) => {
  const fullPath = `/${queryKey[0]}/${getQsNested(queryKey[1] || {})}`;
  const token = queryKey[2];
  const { status, data } = await getWithStatus(fullPath, token);
  if (status !== 200) {
    const error = new Error(`Request failed call for ${fullPath} failed: ${status}`);
    error.code = status;
    throw error;
  }
  return data;
};

export const queryFnWithoutError = async ({ queryKey }) => {
  const fullPath = `/${queryKey[0]}/${getQsNested(queryKey[1] || {})}`;
  const token = queryKey[2];
  const { status, data } = await getWithStatus(fullPath, token, false);
  if (status === 200) {
    return data;
  }
  return;
};

export default queryFn;
